import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/functions'



// firebase init
const firebaseConfig = {
    apiKey: "AIzaSyAPFisyU_G6CBGGqjlW3gqWpDbdw5zqAbU",
    authDomain: "cinepolis-inseparables.firebaseapp.com",
    databaseURL: "https://cinepolis-inseparables.firebaseio.com",
    projectId: "cinepolis-inseparables",
    storageBucket: "cinepolis-inseparables.appspot.com",
    messagingSenderId: "402608633050",
    appId: "1:402608633050:web:72827da12c139112c321e3",
    measurementId: "G-SPZY4PY7LR"
}
firebase.initializeApp(firebaseConfig)

// utils
const db = firebase.firestore()
const auth = firebase.auth()
const storage = firebase.storage()
const functions = firebase.functions()

// collection references
const usersCollection = db.collection('users')
const postsCollection = db.collection('posts')
const commentsCollection = db.collection('comments')
const likesCollection = db.collection('likes')
const ticketsCollection = db.collection('tickets')

// export utils/refs
export {
    db,
    auth,
    storage,
    functions,
    usersCollection,
    postsCollection,
    commentsCollection,
    likesCollection,
    ticketsCollection
}